NtechApp.NotificationList = function($view) {
    var me = this;

    this._$view = null;

    this._ajax = null;
    this._click = null;

    this._notificationManager = null;

    this._construct = function() {
        me._$view = $view;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._notificationManager = new NtechApp.NotificationManager(me._$view);

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-lastNotificationId]", function(e) {
            var $item = $(e.target).closest("[data-lastNotificationId]");
            if($item.hasClass("lockButton"))
                return;

            $item.addClass("lockButton");
            me._loadPrevNotifications($item, $item.attr("data-lastNotificationId"));
        });

        me._bindAjaxPollingUpdates();
    }

    this._bindAjaxPollingUpdates = function() {
        NtechApp.ajaxPolling.addPullRequestParamsResolver(function() {
            var $notifications = me._$view.find("[data-notificationModel]");
            var maxId = NtechApp.getMaxProp($notifications, "data-notificationModel");

            var params = {};
            if(maxId != 0) {
                params["pullListNotifications"] = maxId;
            }
            else {
                params["pullAllListNotifications"] = true;
            }

            return params;
        });

        $(NtechApp.ajaxPolling).on(NtechApp.AjaxPolling.EVENT_ON_DATA_PULL, function(e, data) {
            if(!data.wasListNotificationsUpdated)
                return;

            var $grid = me._$view.find("[data-notificationsListGridContent]");
            $grid.prepend($.parseHTML(data.newListNotificationsHtml));

            NtechApp.dateTools.convertDates(me._$view);
            me._$view.find("[data-notificationsListNoItems]").addClass("hidden");
            me._$view.find("[data-notificationsListGrid]").removeClass("hiddenGrid");
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.NotificationList, {
    _getLoadPrevRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_notifications_load_list_items';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_notifications_load_list_items';
    },

    _loadPrevNotifications: function($item, lastNotificationId) {
        var me = this;
        me._ajax.enableTextLoading($item);
        
        var params = {
            lastNotificationId: lastNotificationId || null
        };

        me._ajax.get({
            url: Routing.generate(me._getLoadPrevRoute(), params),
            onSuccess: function(data) {
                $item.remove();
                me._$view.find("[data-notificationsListGridContent]").append(
                    $($.parseHTML(data.html))
                );

                NtechApp.dateTools.convertDates(me._$view);
            }
        });
    }
});